import {
  additionalRequirementCopy,
  dataRequirementCopy,
  type RequirementCopy,
  spaceTimeRequirementCopy,
  systemRequirementCopy
} from '@shared/all/domains/factiiiRequirementOptions';
import type { FactiiiRequirement } from '@shared/all/domains/factiiis';

import { LUCIDE } from './lucideIcons';

interface RequirementOption {
  value: FactiiiRequirement | null;
  label: string;
  description: string;
  icon: React.ComponentType<{ className?: string }> | null;
}

// The copy lives in shared so web and mobile can never disagree on a label;
// this file only attaches the web icon component to each entry.
const withIcons = (copy: RequirementCopy[]): RequirementOption[] =>
  copy.map(({ icon, ...option }) => ({
    ...option,
    icon: icon ? LUCIDE[icon] : null
  }));

export const allRequirementOptions = withIcons([
  ...dataRequirementCopy,
  ...spaceTimeRequirementCopy,
  ...additionalRequirementCopy,
  ...systemRequirementCopy
]);
